const actions = {
  GET_TABLES_EFFICIENCY: "GET_TABLES_EFFICIENCY",
  GET_TABLES_EFFICIENCY_SUCCESS: "GET_TABLES_EFFICIENCY_SUCCESS",

  getTablesEfficiencyData: (params) => {
    return (dispatch) => {
      dispatch({
        type: actions.GET_TABLES_EFFICIENCY,
        ...params,
      });
    };
  },
};
export default actions;
